import React, { useEffect } from "react";
import { Form, Input, DatePicker, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingClassDetails, 
	doTrainingClassCreate, 
	doTrainingClassUpdate 
} from "../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { 
		DATE_FORMAT_MDY, 
		TIME_FORMAT_24HM,
		DATE_FORMAT,
		TIME_FORMAT
} from "variables/constants";
import dayjs from "dayjs";
import { getLabel } from "utils";


const TrainingClassForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;
	const { RangePicker } = DatePicker;
	
	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { trainingmodule:tcl_title, ...rest } = recordData;

			const initialValues = {
				...rest,
				tcl_id: recordData?.tcl_id ?? "",
				tcl_title: recordData?.tcl_title ?? "",
				tcl_date_range: recordData?.tcl_schedule_date_from && recordData?.tcl_schedule_date_to
									? [dayjs(recordData.tcl_schedule_date_from), dayjs(recordData.tcl_schedule_date_to)]
									: [],
				tcl_client_id: recordData?.tcl_client_id ?? "",
			};
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
    	try {  
			if (formData.tcl_date_range?.length === 2) {
				formData.tcl_schedule_date_from = formData.tcl_date_range[0].format(`${DATE_FORMAT} ${TIME_FORMAT}`);
				formData.tcl_schedule_date_to = formData.tcl_date_range[1].format(`${DATE_FORMAT} ${TIME_FORMAT}`);
				}
				delete formData.tcl_date_range;
				
			formData.tcl_client_id = formData.tcl_client_id & formData.tcl_client_id != '' ? formData.tcl_client_id : 0;
			recordData.tcl_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className={mode !== "view" ? "form" : ""}
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="tcl_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">         		            	            
				<FormItem className="font-medium mb-2 col-span-3"
					name="tcl_title"
					label="Training Class Name"
					rules={[requiredField]}
					
				>
					{mode === 'edit' ?
					<Input id="tcl_title"
						className="input-field"
						maxLength={100}
						placeholder="Enter training module title"
					/>
					: <label className="text-base label-value dark:text-white">{recordData?.tcl_title}</label>
					}
				</FormItem>

			</div>
			<div className="col-span-2 mb-2">
					<div className="grid grid-cols-4 gap-2 w-full">
						<FormItem
							className="font-medium mb-2 col-span-2"
							name="tcl_date_range" 
							label="Class Schedule"
							rules={[requiredField]}
						>
							{mode !== "view" ? (
								<RangePicker
									className="input-field w-full"
									showTime={{ format: TIME_FORMAT_24HM }}
									format={`${DATE_FORMAT_MDY} ${TIME_FORMAT_24HM}`}
									valueFormat="YYYY-MM-DD HH:mm:ss" 
								/>
							) : (
								<label className="text-base label-value dark:text-white">
									{recordData?.tcl_schedule_date_from && recordData?.tcl_schedule_date_to
										? `${dayjs(recordData.tcl_schedule_date_from).format(
											`${DATE_FORMAT_MDY} ${TIME_FORMAT_24HM}`
										)} - ${dayjs(recordData.tcl_schedule_date_to).format(
											`${DATE_FORMAT_MDY} ${TIME_FORMAT_24HM}`
										)}`
									: ""}
								</label>
							)}
						</FormItem>
				
						<FormItem
							label="Client"
							name="tcl_client_id"

						>
							{mode !== "view" ? 
								<Select id="tcl_client_id"
									className="input-field"
									showSearch
									allowClear={true}
									options={recordData?.clientList}
								/>
								: 
								<label className="text-base label-value dark:text-white">
									{getLabel(recordData?.clientList, recordData?.tcl_client_id)}
								</label>
							}
						</FormItem>
					</div>
				</div>

			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
					mode={mode}
					recordId={recordData?.tcl_id ?? 0}
					isModal={true}
					modalId={recordData?.tcl_id > 0 ? 'edit_classModule' : 'add_trainingClass'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingClass.trainingClassDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getTrainingClassDetails(id)),
  	doCreate: (data) => dispatch(doTrainingClassCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingClassUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassForm);
